import React from "react";
import {Route} from "react-router-dom";
import {List, Order} from "../../views/picking/retailer/index";
import RetailerPickingList from "../../views/picking/retailer/showV2";
import RequireAuthentication from "../../hoc/authentication/requireAuthentication";
import RetailerUnloader from "../../hoc/retailer/retailerUnloader";
import RetailerLoader from "../../hoc/retailer/retailerLoader";
import {sessionStore} from "../../utils/sessionStore";
import {BarCodeScannerProvider} from "../../contexts/barCodeScannerContext";

let routes = [];
const applications = sessionStore.get("applications");

if (applications && applications["picking"]) {
    routes.push([
        <Route
            path="/picking/retailers/:id/order/v2/:params"
            component={RequireAuthentication(RetailerLoader((props) => <BarCodeScannerProvider><RetailerPickingList {...props} /></BarCodeScannerProvider>))}
            exact
            key="retailerListV2"
        />,
        <Route
            path="/picking/retailers/:params"
            component={RequireAuthentication(RetailerUnloader(List))}
            exact
            key="retailerList"
        />,
        <Route
            path="/picking/retailers/:id/order/:params"
            component={RequireAuthentication(RetailerLoader(Order))}
            exact
            key="retailerOrder"
        />
    ])
}

export default routes;
